import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics';

const GoogleAnalyticsTracker = () => {
  useGoogleAnalytics();
  return null;
};

export default GoogleAnalyticsTracker;
